import React from "react";

import ThemeToggle from "../../components/profile/ThemeToggle";
import "../../assets/css/font-awesome.min.css";
import "../../assets/css/qrprofile.css";

// Shared visual frame for every village-profile route (the profile grid and the
// single-image view). Keeps the markup + stylesheet imports in one place.
export default function ProfileShell({ children }) {
  return (
    <>
      <div className="top-line"></div>
      <div className="profile-qr">
        <ThemeToggle />
        <div className="profile-qr-container">
          <div className="profile-container">{children}</div>
        </div>
      </div>
    </>
  );
}
